module.exports = __webpack_public_path__ + "static/3-469ba32e47964f4e6518a32c246960fc.jpg";